import React from 'react';
import styled from 'styled-components';
import { size } from '../../layout/helpers';

const StyledImageCover = styled.div`
  background-image: var(--background-image);
  background-size: cover;
  background-position: center;
  height: 100%;
  min-height: calc(100vh - ${size(15)});
  width: 100%;
  display: grid;
  place-items: center;
`;

export interface ImageCoverProps extends React.PropsWithChildren {
  backgroundImageUrl?: string;
}

export const ImageCover: React.FC<ImageCoverProps> = ({ backgroundImageUrl, children }) => {
  return (
    <StyledImageCover
      style={
        {
          '--background-image': `url(${backgroundImageUrl})`,
        } as React.CSSProperties
      }
    >
      {children}
    </StyledImageCover>
  );
};
